import { MouseEvent } from 'react';
import { NavigateFunction } from 'react-router';
import { hasTextSelection } from './has-text-selection';

interface HandlePostCardClickParams {
  event: MouseEvent;
  linkToPost?: boolean;
  navigate: NavigateFunction;
  postPath: string;
}

const INTERACTIVE_SELECTOR = 'a, button, [role="button"], input, label';

export function shouldExpandPostCardOnClick(event: MouseEvent): boolean {
  if (hasTextSelection()) return false;
  const target = event.target;
  return !(target instanceof Element) || !target.closest(INTERACTIVE_SELECTOR);
}

export function handlePostCardClick({
  event,
  linkToPost,
  navigate,
  postPath,
}: HandlePostCardClickParams): void {
  const isSelecting = hasTextSelection();

  if (!isSelecting && linkToPost) {
    if (event.metaKey || event.ctrlKey) {
      window.open(postPath, '_blank');
    } else {
      navigate(postPath);
    }
  } else if (isSelecting) {
    event.preventDefault();
  }
}
